import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { BaseCell, BaseHeader } from './Column';
import { FormattedTime, Responsive } from '../../../../../../ui';

interface IProps {
	scheduledTimeStamp: number;
	actualTimestamp: number;
}

const styles = css`
	min-width: 100px;
	max-width: 100px;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		min-width: auto;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	font-weight: 500;
	display: flex;
	flex-direction: column;
`;

export const StyledFormattedTime = styled(FormattedTime)`
	margin: 0;
`;

export function Header() {
	return <StyledHeader css={styles}>Time</StyledHeader>;
}

export function Cell({ scheduledTimeStamp, actualTimestamp }: IProps) {
	const hasChangeInTime =
		!!actualTimestamp && scheduledTimeStamp !== actualTimestamp;

	return (
		<StyledCell>
			<FormattedTime
				value={scheduledTimeStamp}
				isStrikeThrough={hasChangeInTime}
				screenReaderLabel={hasChangeInTime ? 'Original time' : undefined}
			/>
			{hasChangeInTime && (
				<StyledFormattedTime
					value={actualTimestamp}
					isNewTime={hasChangeInTime}
					screenReaderLabel="Updated time"
				/>
			)}
		</StyledCell>
	);
}
